<template>
  <div v-if="data" class="outsource-label">
    <header class="ol-h">
      <div class="ol-h-left">
        <qr-code id="OutsourceLabelTP" :value="data.value1" width="80" height="80" />
        <div style="font-weight: bold;margin-top: 2px;font-size: 14px">托盘码</div>
      </div>
      <p class="ol-h-title">送货标识卡</p>
      <div class="ol-h-right">
        <img class="ol-h-right-logo" src="@/assets/logoLogin.png" />
        <p class="ol-h-right-cname">{{data.laOutsouceCode}}</p>
        <p class="ol-h-right-cname-cn">{{ data.wxName }}</p>
      </div>
    </header>
    <section class="section-info">
      <p>委外单号：{{data.soCode}}</p>
      <p>送货地址：浙江省宁波县沃洲镇鳌峰路2号</p>
      <p>物料编码：{{data.matCode}}</p>
      <p>物料描述：{{data.matName}}</p>
    </section>
    <section class="section-table">
      <table border="1">
        <tbody>
        <tr>
          <td>通道号</td>
          <td class="val">{{data.whCode}}</td>
          <td>送货日期</td>
          <td class="val">{{ data.printTime}}</td>
        </tr>
        <tr>
          <td>总数</td>
          <td class="val">{{data.matSumQuan }}</td>
          <td>送货数量</td>
          <td class="val">{{data.matQuan }}</td>
        </tr>
        <tr>
          <td>物料批号</td>
          <td class="val">{{data.batchNo }}</td>
          <td>检验方法</td>
          <td class="val">{{data.type }}</td>
        </tr>
        <tr>
          <td>托盘号</td>
          <td class="val">{{data.boxBarcode }}</td>
          <td>本托盘数量</td>
          <td class="val">{{data.matQuan }}</td>
        </tr>
        <tr>
          <td>委外工序</td>
          <td class="val" colspan="3"></td>
        </tr>
        <tr>
          <td>是否返工</td>
          <td class="val" colspan="3">{{data.isFg }}</td>
        </tr>
        <tr>
          <td>工单号</td>
          <td class="val" colspan="3"></td>
        </tr>
        <!--
        <tr>
          <td>备注</td>
          <td class="val" colspan="3"></td>
        </tr>-->
        </tbody>
      </table>
      <div class="wms-qrcode">
        <qr-code id="OutsourceLabelWMS" :value="data.value2" text="WMS二维码" width="240" height="240" />
        <div style="font-weight: bold;margin-top: 5px;font-size: 25px">WMS二维码</div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  name: 'OutsourceLabelReturn',
  props: {
    data: {
      type: Object,
      default: ()=> null
    }
  }
}
</script>
<style scoped>
.outsource-label{
  color: #000;
  width: 100%;
  height: auto;
  padding: 12px;
  box-sizing: border-box;
  /*border: 1px solid blue;*/
}
.outsource-label >header{
  text-align: center;
}

.ol-h{
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  padding-bottom: 6px;
  margin-bottom: 12px;
  border-bottom: 2px solid #000;
}
.ol-h-title{
  flex-shrink: 0;
  font-size: 24px;
  font-weight: bold;
}
.ol-h-left,.ol-h-right{
  flex: 1;
}
.ol-h-right{
  display: flex;
  align-items: flex-end;
  flex-direction: column;
}
.ol-h-right-logo{
  margin-top: auto;
  height: 20px;
  width: auto;
}
.ol-h-right-cname{
  font-weight: bold;
  font-size: 18px;
  margin: 0;
}
.ol-h-right-cname-cn{
  font-weight: bold;
  font-size: 18px;
  margin: 0;
}
.section-info{
  margin-bottom: 12px;
}
.section-info >p{
  font-weight: bold;
  font-size: 20px;
  line-height: 1;
  margin: 5px 0;
}
.section-table{
  display: flex;
  align-items: center;
}
.section-table >table{
  flex: 1;
  height: 320px;
  border-collapse: collapse;
}
.section-table >table td{
  padding: 8px;
  font-size: 16px;
  font-weight: bold;
}
.section-table >table td.val{
  font-size: 20px;
}
.section-table >.wms-qrcode{
  text-align: center;
  flex-shrink: 0;
  padding: 0 12px 0 24px;
}
</style>
